import { AuthTypeS } from '@/features/Auth/outbound/share';
import { CustomEventWithDetail, CustomEventWithoutDetail } from 'rune-ts';

export class ChangeEmailEvent extends CustomEventWithDetail<{ email: string }> {}

export class ChangePasswordEvent extends CustomEventWithoutDetail {}

export class SnsDisconnectEvent extends CustomEventWithDetail<{
  email: string;
  nickname: string;
  sns_type: AuthTypeS.USER_SNS_TYPE;
}> {}

export class ChangeProfileImageEvent extends CustomEventWithDetail<{ file_url: string }> {}
